import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import SoldxHeader from "../../../components/SoldxHeader"
import SoldxBreadcrumb from "../../../components/SoldxBreadcrumb"
import SoldxLandingFooter from "../../../components/SoldxLandingFooter"

const HERO_IMG =
  "https://images.unsplash.com/photo-1554435493-93422e8220c8?w=800&h=600&fit=crop"
const MARKETING_IMG =
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=500&fit=crop"
const FORM_IMG =
  "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&h=500&fit=crop"

const BROKER_SERVICES = [
  {
    title: "Qualified Leads",
    description:
      "Access A Curated List Of Verified, Ready-To-Act Buyers, Maximizing Reach And Higher Conversion Rates.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=280&fit=crop",
  },
  {
    title: "High-Quality Property Visuals",
    description:
      "Showcase Properties With Stunning Photos, 3D Virtual Tours, And Videos That Attract Attention And Drive Engagements.",
    image: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=400&h=280&fit=crop",
  },
  {
    title: "In-Built CRM",
    description:
      "Manage Your Client Relationships Seamlessly With Our Integrated CRM, Streamlining Communication And Follow-Ups.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=280&fit=crop",
  },
  {
    title: "Live Property Analysis",
    description:
      "Track Real-Time Data And Insights On Your Property's Performance To Make Informed Business Decisions.",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=280&fit=crop",
  },
]

const Broker = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    mobile: "",
    state: "Delhi",
    query: "",
  })

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // TODO: submit to API
  }

  return (
    <div className="soldx-landing soldx-broker-page">
      <SoldxHeader solid />

      {/* Hero: rounded blue gradient box + image */}


      <section className="soldx-broker-hero soldx-hero-modern">
        <div className="soldx-hero-modern-inner">
          <div className="soldx-hero-modern-card">

            <SoldxBreadcrumb variant="hero" heroTone="dark" className="mb-5" />

            <p className="soldx-hero-modern-slogan">Partner for Growth</p>
            <h1 className="soldx-hero-modern-title">
              <span className="soldx-hero-modern-title-bold">Enhance Your</span>
              <span className="soldx-hero-modern-title-italic">Transaction Efficiency</span>
              <span className="soldx-hero-modern-title-bold">Today</span>
            </h1>
            <Link to="/login" className="soldx-hero-modern-cta">
              GET STARTED
            </Link>
          </div>
          <div className="soldx-hero-modern-img">
            <img src={HERO_IMG} alt="Commercial real estate" />
          </div>
        </div>
      </section>

      {/* A Partnership Built for Success */}
      <section className="soldx-broker-section soldx-broker-partnership">
        <Container>
          <div className="soldx-broker-partnership-inner">
            <h2 className="soldx-broker-section-title">A Partnership Built for Success</h2>
            <p className="soldx-broker-section-text">
              Our partnership with brokers connects you to global investors and extends your
              market reach. With digital transparency, verified buyers, and streamlined processes,
              we help you close more transactions with greater certainty.
            </p>
            <Link to="/login" className="soldx-broker-btn soldx-broker-btn-primary">
              GET STARTED
            </Link>
          </div>
        </Container>
      </section>

      {/* How Auction Works For Sellers */}
      <section className="soldx-broker-section soldx-broker-steps">
        <Container>
          <h2 className="soldx-broker-steps-title">How Auction Works For Sellers</h2>
          <Row className="g-3 justify-content-center">
            <Col sm={6} md={4}>
              <div className="soldx-broker-step-tab">Sign Up</div>
            </Col>
            <Col sm={6} md={4}>
              <div className="soldx-broker-step-tab">List Your Property</div>
            </Col>
            <Col sm={6} md={4}>
              <div className="soldx-broker-step-tab">Auction Setup</div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Accelerate Demand with Powerful Marketing */}
      <section className="soldx-broker-section soldx-broker-marketing">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6} className="order-lg-1 order-2">
              <div>
                <h2 className="soldx-broker-marketing-title">
                  Accelerate Demand with Powerful Marketing
                </h2>
                <p className="soldx-broker-section-text">
                  We partner with brokers to drive demand through custom campaigns, targeted
                  outreach, and powerful digital marketing. Maximize reach and attract the right
                  buyers for every listing.
                </p>
                <Link to="/login" className="soldx-broker-btn soldx-broker-btn-primary">
                  GET STARTED
                </Link>
              </div>
            </Col>
            <Col lg={6} className="order-lg-2 order-1">
              <div className="soldx-broker-marketing-img">
                <img src={MARKETING_IMG} alt="Marketing" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Services for broker */}
      <section className="soldx-broker-section soldx-broker-services">
        <Container>
          <h2 className="soldx-broker-steps-title">Our Services for broker</h2>
          <Row className="g-4">
            {BROKER_SERVICES.map((service) => (
              <Col md={6} lg={3} key={service.title}>
                <div className="soldx-broker-service-card">
                  <div className="soldx-broker-service-img">
                    <img src={service.image} alt={service.title} />
                  </div>
                  <h3 className="soldx-broker-service-title">{service.title}</h3>
                  <p className="soldx-broker-service-text">{service.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact Form */}
      <section className="soldx-broker-section soldx-broker-form-section">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <div className="soldx-broker-form-wrap">
                <h2 className="soldx-broker-form-title">
                  Learn More About How Soldx Help You Close More Transactions Faster And With
                  Certainty.
                </h2>
                <p className="soldx-broker-form-sub">Please enter your details.</p>
                <form onSubmit={handleSubmit} className="soldx-broker-form">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={form.name}
                    onChange={handleChange}
                    className="soldx-broker-input"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={form.email}
                    onChange={handleChange}
                    className="soldx-broker-input"
                  />
                  <input
                    type="text"
                    name="company"
                    placeholder="Company Name"
                    value={form.company}
                    onChange={handleChange}
                    className="soldx-broker-input"
                  />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Phone"
                    value={form.mobile}
                    onChange={handleChange}
                    className="soldx-broker-input"
                  />
                  <select
                    name="state"
                    value={form.state}
                    onChange={handleChange}
                    className="soldx-broker-input soldx-broker-select"
                  >
                    <option value="Delhi">Delhi</option>
                    <option value="Maharashtra">Maharashtra</option>
                    <option value="Karnataka">Karnataka</option>
                    <option value="Tamil Nadu">Tamil Nadu</option>
                    <option value="Other">Other</option>
                  </select>
                  <textarea
                    name="query"
                    placeholder="Your Query"
                    value={form.query}
                    onChange={handleChange}
                    rows={4}
                    className="soldx-broker-input soldx-broker-textarea"
                  />
                  <button type="submit" className="soldx-broker-btn soldx-broker-btn-primary">
                    GET STARTED
                  </button>
                </form>
              </div>
            </Col>
            <Col lg={6}>
              <div className="soldx-broker-form-img">
                <img src={FORM_IMG} alt="Properties" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <SoldxLandingFooter />
    </div>
  )
}

export default Broker
